'use client'

import { MolarMassCalculator } from '@/components/MolarMassCalculator'
import { Calculator } from 'lucide-react'
import { useTranslations } from 'next-intl'

export default function CalculatorPage() {
  const t = useTranslations('Calculator')

  return (
    <div className="min-h-screen bg-[#0a192f] py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-block p-4 bg-[#64ffda]/10 rounded-full mb-4">
            <Calculator size={48} className="text-[#64ffda]" />
          </div>
          <h1 className="text-5xl font-bold text-white mb-4">
            {t('title')}
          </h1>
          <p className="text-xl text-[#a8b2d1] max-w-2xl mx-auto">
            {t('subtitle')}
          </p>
        </div>

        <MolarMassCalculator />

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <div className="p-6 bg-[#112240] border-2 border-[#233554] rounded-xl">
            <h3 className="text-xl font-semibold text-[#64ffda] mb-3">
              {t('howToUse')}
            </h3>
            <ul className="space-y-2 text-[#a8b2d1]">
              <li className="flex items-start gap-2">
                <span className="text-[#64ffda] font-bold">1.</span>
                <span>{t('step1')}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#64ffda] font-bold">2.</span>
                <span>{t('step2')}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#64ffda] font-bold">3.</span>
                <span>{t('step3')}</span>
              </li>
            </ul>
          </div>

          <div className="p-6 bg-[#112240] border-2 border-[#233554] rounded-xl">
            <h3 className="text-xl font-semibold text-[#64ffda] mb-3">
              {t('commonFormulas')}
            </h3>
            <div className="space-y-2 text-[#a8b2d1]">
              <div className="flex justify-between items-center">
                <span className="font-mono text-white">H₂O</span>
                <span>{t('water')}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-mono text-white">CO₂</span>
                <span>{t('carbonDioxide')}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-mono text-white">C₆H₁₂O₆</span>
                <span>{t('glucose')}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-mono text-white">NaCl</span>
                <span>{t('sodiumChloride')}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="font-mono text-white">H₂SO₄</span>
                <span>{t('sulfuricAcid')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
